<script lang="ts">
    import { createEventDispatcher } from 'svelte';

    import Modal from './Modal.svelte';

    export let showModal = false;
    export let modalWidth = 400;

    const dispatch = createEventDispatcher<{ yes: void; no: void }>();

    const hideConfirm = (): void => {
        showModal = false;
    };

    const raiseYes = (): void => {
        dispatch('yes');
        hideConfirm();
    };

    const raiseNo = (): void => {
        dispatch('no');
        hideConfirm();
    };
</script>

<Modal bind:showModal={showModal} bind:modalWidth>
    <div slot="header">Confirm</div>
    <div slot="body" class="confirm-body">
        <slot name="body">Are you sure you want to discard your changes?</slot>
    </div>
    <div slot="footer" class="confirm-footer">
        <button type="button" class="btn secondary" on:click|preventDefault={raiseNo}>Cancel</button>
        <button type="button" class="btn danger" on:click|preventDefault={raiseYes}>Yes</button>
    </div>
</Modal>

<style>
    .confirm-body {
        width: 100%;
        color: var(--grey);
        font-size: inherit;
        line-height: 1.5;
        text-align: left;
    }

    .confirm-body :global(p) {
        margin: 0;
        word-wrap: break-word;
        overflow-wrap: break-word;
    }

    .confirm-footer {
        display: flex;
        justify-content: flex-end;
        gap: var(--space-3);
        width: 100%;
    }

    .btn {
        border: 0;
        border-radius: var(--border-radius-button);
        padding: var(--space-3) var(--space-5);
        font-weight: 500;
        cursor: pointer;
        box-shadow: var(--shadow-cta);
    }

    .btn.secondary {
        background: var(--greyish);
        color: var(--grey);
    }

    .btn.danger {
        background: var(--status-danger);
        color: var(--white);
    }

    .btn:focus-visible {
        outline: none;
        box-shadow: var(--focus-ring);
    }

    .btn:disabled {
        opacity: 0.7;
        cursor: not-allowed;
    }
</style>
